<div class="row">
  <div class="col">
    <div class="input-group input-group-sm">
      <input type="text" #search class="form-control form-control-sm" [placeholder]="'admin.users.filter.placeHolder' | translate" />
      <span class="input-group-prepend">
        <span class="input-group-text">
          <i class="icofont icofont-search"></i>
        </span>
      </span>
    </div>
  </div>
</div>
<div class="card">
  <div class="table-responsive">
    <table class="table table-striped table-condensed">
      <thead>
        <tr>
          <th [innerHtml]="'NomPrénom(s)' | translate"></th>
          <th [innerHtml]="'Email' | translate"></th>
          <th [innerHtml]="'role' | translate"></th>
          <th [innerHtml]="'Creation' | translate"></th>
          <th [innerHtml]="'CreatedBy' | translate"></th>
          <th [innerHtml]="'LastLoginDate' | translate"></th>
          <th class="actions" [innerHtml]="'Actions' | translate"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let user of users
              | paginate
                : {
                    itemsPerPage: pageSize,
                    currentPage: page + 1,
                    totalItems: totalItems,
                  }
          "
          [ngClass]="{ inactive: !user.active }"
        >
          <td><a [routerLink]="[user.id]">{{ user.lastName }} {{ user.firstName }}</a></td>
          <td><a [routerLink]="[user.id]">{{ user.email }}</a></td>
          <td>{{ user.profile }}</td>
          <td>
            <app-timestamp-cell [value]="user.createdAt" />
          </td>
          <td>{{ user.createdBy?.lastName }} {{ user.createdBy?.firstName }}</td>
          <td>
            <app-timestamp-cell [value]="user.lastLoginDate" />
          </td>
          <td class="actions">
            <a [routerLink]="[user.id]"><i class="icofont icofont-edit-alt" title="Editer"></i></a>
            <i (click)="modalRemove(user)" class="icofont icofont-ui-delete" title="Supprimer"></i>
            <i
              *ngIf="!user.lastLoginDate"
              (click)="resendRegistrationMail(user)"
              class="icofont icofont-send-mail"
              [title]="'ResendRegistrationEmail' | translate"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="float-right mr-2">
      <pagination-controls
        class="pull-right"
        (pageChange)="changePage($event)"
        previousLabel="{{ 'Previous' | translate }}"
        nextLabel="{{ 'Next' | translate }}"
      ></pagination-controls>
      <div class="pull-right mr-4 total-admin">Total : {{ totalItems }}</div>
    </div>
  </div>
</div>

<!-- POPUP REMOVE USER -->
<app-modal-basic #remove [dialogClass]="'modal-md'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      <small [innerHtml]="'Confirmation de suppression'"></small>
    </h4>
  </div>
  <div class="app-modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="label label-primary">Nom</label>
          <p>{{ user?.lastName }}</p>
        </div>
        <div class="form-group">
          <label class="label label-primary">Prénom(s)</label>
          <p>{{ user?.firstName }}</p>
        </div>
        <div class="form-group">
          <label class="label label-primary">Email</label>
          <p>{{ user?.email }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button (click)="removeUser()" class="btn btn-sm btn-primary" [innerHtml]="'Supprimer'"></button>&nbsp;
    <button (click)="remove.hide()" class="btn btn-sm btn-danger" [innerHtml]="'Annuler'"></button>
  </div>
</app-modal-basic>
